// extracted by mini-css-extract-plugin
export default {"header":"eCFc0","spacer":"NphjH","flexible_block":"HCXyD","logo_place":"I93mw","right_block":"GTbGd","list_move":"eyTeF"};